const comments = [
  {
    name: '追剧达人小王',
    text: '桔子影视真的是我追剧的首选平台！更新速度超快，画质清晰流畅，而且完全免费。最近在追《锦绣芳华》，每天蹲更新已经成了我的日常。',
    drama: '在看《锦绣芳华》',
    time: '2 小时前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20portrait%20icon%20with%20orange%20and%20gold%20gradient%20background%2C%20minimalist%20geometric%20style%2C%20soft%20rounded%20edges%2C%20clean%20avatar%20design%2C%20flat%20illustration%20aesthetic&width=80&height=80&seq=juzi-avatar-01&orientation=squarish',
  },
  {
    name: '悬疑剧发烧友',
    text: '一口气追完《暗夜追击》全 36 集，剧情太烧脑了！桔子影视的全集一次性放出来这点太良心了，不用等更新，一追到底。推荐给所有喜欢悬疑的朋友！',
    drama: '在看《暗夜追击》',
    time: '5 小时前',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20abstract%20profile%20icon%20with%20geometric%20shapes%2C%20minimalist%20design%2C%20soft%20gradient%20background%2C%20clean%20modern%20avatar%20style%2C%20flat%20vector%20aesthetic&width=80&height=80&seq=juzi-avatar-02&orientation=squarish',
  },
  {
    name: '美剧控阿琳',
    text: '在桔子影视找到了好多冷门高分美剧，资源真的全！而且播放体验特别好，从来没有卡顿过。现在每天下班回来就是打开桔子影视，已经成了生活习惯。',
    drama: '在看《未来之城 2049》',
    time: '昨天',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20warm%20toned%20abstract%20avatar%20with%20round%20geometric%20elements%2C%20minimalist%20illustration%20style%2C%20orange%20and%20cream%20gradient%2C%20clean%20simple%20design%2C%20modern%20flat%20icon%20aesthetic&width=80&height=80&seq=juzi-avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-chat-3-line text-sm w-4 h-4 flex items-center justify-center"></i>
            用户好评
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">追剧达人说</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">来自桔子影视用户的真实追剧体验分享。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</p>
                  <p className="text-[11px] text-foreground-400 whitespace-nowrap">{comment.time}</p>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-50 text-primary-600 text-[10px] font-medium whitespace-nowrap">
                <i className="ri-eye-line text-[10px] w-3 h-3 flex items-center justify-center"></i>
                {comment.drama}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}